<template>
  <div id="intro" class="article-intro" :class="classes">
    <h3 v-if="text" class="text">{{ text }}</h3>
    <div v-else class="text">
      <slot name="content" />
    </div>
    <Button
      v-if="linkButton"
      theme="underline"
      tag="button"
      class="linkButton"
      @click="scrollToItem(link)"
    >
      {{ linkButton }}
    </Button>
    <Button
      v-else-if="hrefButton"
      theme="underline"
      tag="a"
      class="hrefButton"
      :href="hrefLink"
    >
      {{ hrefButton }}
    </Button>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import { scrollIntoViewWithOffset } from "@/helpers/scroll.js";
export default {
  name: "ArticleIntro",
  components: {
    Button,
  },
  props: {
    text: {
      type: String,
      default: null,
    },
    centered: {
      type: Boolean,
      default: false,
    },
    linkButton: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
    hrefButton: {
      type: String,
      default: null,
    },
    hrefLink: {
      type: String,
      default: null,
    },
    largeFont: {
      type: String,
      default: null,
    },
  },
  computed: {
    classes() {
      return {
        "article-intro--centered": this.centered,
        "article-intro--largeFont": this.largeFont,
      };
    },
  },
  methods: {
    scrollToItem(link) {
      const element = document.querySelector(link);
      if (!element) {
        return;
      }
      scrollIntoViewWithOffset(element, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
.article-intro {
  padding: 60px 20px 60px;
  @include respond-above(md) {
    padding: 80px 20px 80px;
  }

  &--centered {
    text-align: center;
  }
  &--largeFont {
    .text {
      :slotted(p) {
        font-size: 32px;
      }
    }
  }
}

.text {
  color: $color-grey-dark;

  margin: 0 auto;
  max-width: 100%;
  @include t__editorial-body-20;
  @include respond-above(md) {
    @include t__editorial-sub-headline-30;
    max-width: 1073px;
  }
}
:slotted(p) {
  @include t__editorial-body-20;
  margin: 0 0 15px 0;
  @include respond-above(md) {
    @include t__editorial-sub-headline-30;
    margin: 0 0 40px 0;
  }
  &:last-child {
    @include respond-above(md) {
      margin: 0 0 0 0;
    }
  }
}

:slotted(b) {
  display: block;
  margin: 0 0 20px;
  @include respond-above(md) {
    margin: 0 0 40px;
  }
}

:slotted(h1) {
  @include t__editorial-headline-20;
  margin: 15px 0 20px 0;
  @include respond-above(md) {
    margin: 0 0 50px 0;
    @include t__editorial-headline-50;
  }
}

.linkButton {
  font-family: $utility-font-family;
  margin-top: 20px;
  font-size: 11px;
  @include respond-above(md) {
    font-size: 14px;
    margin-top: 50px;
  }
}

.hrefButton {
  display: inline-block;
  font-family: $utility-font-family;
  margin-top: 20px;
  font-size: 11px;
  @include respond-above(md) {
    font-size: 14px;
    margin-top: 50px;
  }
}

.text :slotted(span) {
  margin: 20px 0 0;
  display: block;
  @include respond-above(md) {
    margin: 40px 0 0;
  }
}
</style>
